import { render, staticRenderFns } from "./partsSearch.vue?vue&type=template&id=644d3bb8&scoped=true&"
import script from "./partsSearch.vue?vue&type=script&lang=js&"
export * from "./partsSearch.vue?vue&type=script&lang=js&"
import style0 from "./partsSearch.vue?vue&type=style&index=0&id=644d3bb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644d3bb8",
  null
  
)

export default component.exports